import { getEnvVars, getGraphQLEndpoint } from '@order/utils';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * The domain AWS WAF issues tokens for: the GraphQL host, or `AWS_WAF_TOKEN_DOMAIN` when
 * GraphQL goes through a local proxy, since AWS WAF only accepts tokens for the protected host.
 */
export function getAwsWafTokenDomain(): string {
  const tokenDomain: string | undefined = getEnvVars().AWS_WAF_TOKEN_DOMAIN;

  return tokenDomain || new URL(getGraphQLEndpoint()).hostname;
}
